import React from "react";
import { Chart as ChartJS,  CategoryScale,  LinearScale,  PointElement,  LineElement,  Title,  Tooltip,  Legend,} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register( CategoryScale,  LinearScale,  PointElement,  LineElement,  Title,  Tooltip,  Legend);


const AvtMultiLineChart = ({chartlabels,distanceitems,fuelitems,averageitems}) => {
  

 
  const data = {
  labels: chartlabels,
  datasets: [
    {
      label: "Distance Travelled",
      data: distanceitems,
       borderColor: "rgba(255, 99, 132, 1)",
      backgroundColor: "rgba(255, 99, 132, 0.2)",
      tension: 0.4,
    },
    {
      label: "Fuel Consumed",
      data: fuelitems,
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 0.2)",
      tension: 0.4,
    },
    {
      label: "Average in km/litre",
      data: averageitems,
      borderColor: "rgba(54, 162, 235, 1)",
      backgroundColor: "rgba(54, 162, 235, 0.2)",
      tension: 0.4,
    },
  ],
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "AVT MultiLine Chart",
    },
  },
};




 
  return (
    
      <Line data={data} options={options} />

    
    
  );
};

export default AvtMultiLineChart;

